import React from "react";
import {
  Backdrop,
  CardHeader,
  Checkbox,
  CircularProgress,
  Grid,
} from "@mui/material";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { LoadingButton } from "@mui/lab";
import useMenu from "./Menu.hook";

const Menu = () => {
  const {
    handleSelectAll,
    handleReset,
    handleSave,
    handleChange,
    loading,
    loadingButton,
    store,
    selectAll,
    productsList,
  } = useMenu();
  if (!store) {
    return (
      <div className="bg-white grid grid-cols-3 lg:grid-cols-1 gap-4 p-4  mt-3">
        Please select store
      </div>
    );
  }
  return (
    <Card className="my-2 bg-white shadow-sm">
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <CardHeader
        title={
          <div className="flex flex-wrap justify-between items-center">
            <div className="text-[#24211F] text-base font-medium">
              Select which products will be displayed in your cool alerts
            </div>
            <div className="flex gap-2">
              <LoadingButton
                className="text-[#C12637] border font-normal bg-white border-[#C12637]"
                variant="outline"
                style={{ border: "1px solid" }}
                disabled={loadingButton}
                onClick={() => handleSelectAll()}
              >
                {selectAll ? "UnSelect All" : "Select All"}
              </LoadingButton>
              <LoadingButton
                className="text-[#C12637] border font-normal bg-white border-[#C12637]"
                variant="outline"
                style={{ border: "1px solid" }}
                onClick={() => handleReset()}
                disabled={loadingButton}
              >
                Reset
              </LoadingButton>
              <LoadingButton
                loading={loadingButton}
                disabled={loadingButton}
                variant="outline"
                onClick={() => handleSave()}
                className="text-white  bg-[#C12637] font-medium border-[#C12637]"
              >
                Save
              </LoadingButton>
            </div>
          </div>
        }
      ></CardHeader>
      <div style={{ border: "1px solid #ccc" }}>
        <CardContent>
          <Grid container spacing={2} alignItems={"center"}>
            {productsList?.map((i) => {
              return (
                <>
                  <Grid item xs={12} md={4}>
                    <Checkbox
                      id={`intProductTypeID ${i?.intProductTypeID}`}
                      name={`intProductTypeID ${i?.intProductTypeID}`}
                      checked={i?.bitActive ? true : i?.bitMasterProduct ? true: false}
                      disabled={i?.bitActive ? true :false}
                      sx={{
                        "&.Mui-checked": {
                          color: "#C12637",
                          opacity: i?.bitActive ? "0.5":"1"
                        },
                      }}
                      onChange={(e) =>
                        handleChange(i?.intProductTypeID, e.target.checked)
                      }
                    />
                    {i?.vchProductTypeName}
                  </Grid>
                </>
              );
            })}
          </Grid>
        </CardContent>
      </div>
    </Card>
  );
};

export default Menu;
